export const GET_LIST_TRANSACTIONS = "GET_LIST_TRANSACTIONS"
export const GET_LIST_TRANSACTIONS_ERR = "GET_LIST_TRANSACTIONS_ERR"

export const EXPORT_EXCEL_LIST_TRANSACTION = "EXPORT_EXCEL_LIST_TRANSACTION"
export const EXPORT_EXCEL_LIST_TRANSACTION_ERR = "EXPORT_EXCEL_LIST_TRANSACTION_ERR"

export const CLEAR_LIST_TRANSACTION = "CLEAR_LIST_TRANSACTION"